var map = {
	"./0.png": "e509",
	"./1.png": "b09a",
	"./2.png": "e30a",
	"./3.png": "953a",
	"./4.png": "b45a",
	"./5.png": "387f",
	"./6.png": "b8ca",
	"./7.png": "2065",
	"./8.png": "11f4",
	"./9.png": "f58a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "459f";